import React from 'react';
import { createRoot } from 'react-dom/client';
// The client main script
import App from './App';

import * as serviceWorker from './serviceWorker';

import './index.css';
import 'typeface-roboto';

// Loads the "App", which is the main script
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register({});
